<template>
  <router-view name="deliveryZone" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "DeliveryZone",
};
</script>
